import React, {useMemo} from 'react'
import constants from 'helpers/constants';
import EntityProfileProvider from 'components/organisms/Providers/ProfileProvider/EntityProfileProvider';
import {useDatabaseEntityGroups, useDatabaseEntitySections} from 'services/entity/entity.utils';
import {useProviderView} from 'helpers/hooks/utils';
import {useViewList} from 'services/view/view.hooks';
import utils from 'helpers/utils';
import {useAuthClientId} from 'components/organisms/Providers/AuthProvider/AuthProvider';

const DatabaseEntityProfileProvider = (props) => {
  const clientId = useAuthClientId();

  const views = useViewList({
    relationType: 'database',
    relationId: 0,
    subscribed: true,
    allPages: true
  }, {
    enabled: utils.isDefined(clientId)
  });
  const view = useProviderView('database.entity', views?.data, props.skipView);

  const groups = useDatabaseEntityGroups(view);
  const sections = useDatabaseEntitySections(view);

  // isLoading anything, is loading something definition related
  const isLoading = props?.isLoading || views.status?.isLoading;
  const isDefinitionsLoading = props?.isDefinitionsLoading;

  const cardDefinitions = useMemo(() => {
    return groups?.length > 0 ? groups : null;
  }, [groups]);

  const sectionDefinitions = useMemo(() => {
    return sections?.length > 0 ? sections : null;
  }, [sections]);

  const options = useMemo(() => ({
    cardState: {
      options: {
        name: 'databaseEntity',
        type: constants.appState.type.local
      }
    },
    graphState: {
      options: {
        name: 'databaseEntity',
        type: constants.appState.type.local
      }
    },
    assistantState: {
      options: {
        name: 'databaseEntity',
        type: constants.appState.type.local
      }
    },
    cardDefinitions,
    sectionDefinitions
  }), [cardDefinitions, sectionDefinitions]);

  const fieldData = useMemo(() => {
    return {};
  }, []);

  const updaters = useMemo(() => {
    return {}
  }, []);

  return <EntityProfileProvider {...props}
                                view={view}
                                options={options}
                                fieldData={fieldData}
                                updaters={updaters}
                                isDefinitionsLoading={isDefinitionsLoading}
                                isLoading={isLoading}>
    {props.children}
  </EntityProfileProvider>
};

DatabaseEntityProfileProvider.propTypes = {
}

export default DatabaseEntityProfileProvider;
